import type { Truthy } from 'lodash';

export function truthy<T>(value: T): value is Truthy<T> {
  return !!value;
}
